// Fronted/src/App.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import { AdminProvider } from './contexts/AdminContext';
import AppContextProvider from './contexts/AppContextProvider';
import AppRoutes from './routes';

function App() {
  // Check if we're on an admin page to hide the navbar
  const isAdminPage = window.location.pathname.startsWith('/admin');

  return (
    <AppContextProvider>
      <BrowserRouter>
      
        {!isAdminPage ?
        <div className="min-h-screen bg-gray-100 font-gothic">
        <NavBar />
        <AppRoutes />
        <Footer/>
      </div>: <AdminProvider>
        <AppRoutes/>
        <Footer/>
        </AdminProvider>}
    </BrowserRouter>
    </AppContextProvider>
  );
}

export default App;
